const Faqs = () => {
  // Fetch all faq accordion headings
  const headings = document.querySelectorAll('[data-question]');
  // Fetch all faq accordion answers
  const answers = document.querySelectorAll('[data-answer]');

  // Loop through each heading
  Array.from(headings).forEach((heading) => {
    // Store the corresponding answer to the question heading
    const target = heading.getAttribute('data-question');

    // If this answer exists, proceed
    if (typeof target !== 'undefined' && target != null) {
      // Add a click event to the heading
      heading.addEventListener('click', () => {
        // If the heading is already open, close it and return
        if (heading.classList.contains('open')) {
          heading.classList.remove('open');
          const content = document.querySelector(`[data-answer="${target}"]`);
          content.classList.remove('open');
          return;
        }

        // Remove the open class from all headings
        headings.forEach((heading) => {
          heading.classList.remove('open');
        });

        // Remove the open class from all answers
        answers.forEach((answer) => {
          answer.classList.remove('open');
        });

        // Fetch the element containing the answer
        const content = document.querySelector(`[data-answer="${target}"]`);

        // If we have an answer element, proceed
        if (typeof content !== 'undefined' && content != null) {
          // Toggle the open/closed state for this accordion item
          heading.classList.toggle('open');
          // Toggle the visibility of the content for this question/heading
          content.classList.toggle('open');
        }
      });
    }
  });
};

export default Faqs;
